'use client'
import {
  context_default,
  useSearch
} from "./chunk-WOKBAUXU.mjs";
import {
  IconItem_default,
  LineClamp_default,
  ListItem_default,
  ThemeMenu_default,
  ThemePopover_default,
  Weather_default
} from "./chunk-RFVCAZY5.mjs";
import {
  useConfig_default
} from "./chunk-7WWZDHPB.mjs";
import {
  ContentfulButton_default
} from "./chunk-2YBW2YZW.mjs";
import {
  DecoratedSection_default
} from "./chunk-BK6LVH5K.mjs";
import {
  ContentfulMedia_default,
  ThemeButton_default
} from "./chunk-XIZE6A22.mjs";
import {
  useFavorites
} from "./chunk-BB4H5TUC.mjs";
import {
  context_default as context_default2,
  useItinerary
} from "./chunk-YBJOQHTL.mjs";
import {
  useFilterQuery_default
} from "./chunk-7GAGCG6W.mjs";
import {
  useGetEventsList
} from "./chunk-I4GWSKHL.mjs";
import {
  useGetCategories
} from "./chunk-HKGNX5TB.mjs";
import {
  __async,
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/components/layout/Layout.tsx
import { Fragment as Fragment10, Suspense } from "react";
import { useRouter as useRouter19 } from "@wbk/config";

// src/context/search/provider.tsx
import { useRef, useState } from "react";
import { getItem, safeParseJson, setItem, splitDateTime } from "@wbk/utils";
import { useRouter } from "@wbk/config";
import { jsx } from "react/jsx-runtime";
var searchDefaultValues = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const category = searchParams.get("category") || "";
  const search = searchParams.get("search") || void 0;
  const dateFrom = searchParams.get("from");
  const dateTo = searchParams.get("to");
  const from = dateFrom ? new Date(dateFrom) : void 0;
  const to = dateTo ? new Date(dateTo) : void 0;
  const prevHistory = getItem("search_history") || "";
  const searchHistory = safeParseJson(prevHistory);
  return {
    category,
    searchHistory,
    search,
    searchState: "",
    from,
    to,
    showPopover: false
  };
};
var SearchProvider = ({ children }) => {
  const { locale, push } = useRouter();
  const [state, setState] = useState(searchDefaultValues());
  const timeoutRef = useRef(void 0);
  const canFetch = typeof state.search === "string";
  const { query } = useFilterQuery_default({
    state: {
      search: state.search || "",
      category: state.category || "",
      from: state.from,
      to: state.to,
      perPage: 10
    }
  });
  const { data: events, isFetching } = useGetEventsList(query, { enabled: canFetch });
  const togglePopover = (state2) => {
    setState((prevState) => __spreadProps(__spreadValues({}, prevState), { showPopover: state2 }));
  };
  const onSearch = (val) => {
    const value = val || "";
    setState((prevState) => __spreadProps(__spreadValues({}, prevState), { searchState: value }));
    clearTimeout(timeoutRef.current);
    if (!val) {
      return setState((prevState) => __spreadProps(__spreadValues({}, prevState), { search: "" }));
    }
    timeoutRef.current = setTimeout(() => {
      saveSearch(value);
    }, 500);
  };
  const setCategory = (category) => {
    setState((prevState) => __spreadProps(__spreadValues({}, prevState), { category: category || "" }));
  };
  const setDate = (from, to) => {
    setState((prevState) => __spreadProps(__spreadValues({}, prevState), { from, to }));
  };
  const saveSearch = (value) => {
    setState((prevState) => __spreadProps(__spreadValues({}, prevState), { search: value }));
    if (value && value.length > 2) {
      const prevHistory = getItem("search_history");
      const history = prevHistory ? JSON.parse(prevHistory) : [];
      if (!(history == null ? void 0 : history.includes(value == null ? void 0 : value.trim()))) {
        const newHistory = history.concat(value).slice(-5);
        setState((prevState) => __spreadProps(__spreadValues({}, prevState), { searchHistory: newHistory }));
        setItem("search_history", JSON.stringify(newHistory));
      }
    }
  };
  const clearHistory = () => {
    localStorage.removeItem("search_history");
    setState((prevState) => __spreadProps(__spreadValues({}, prevState), { searchHistory: [] }));
  };
  const onSubmit = () => {
    var _a, _b, _c;
    const searchParams = new URLSearchParams();
    if (state.from) {
      const from = splitDateTime(state.from, "en", { month: "2-digit", day: "2-digit" }).date;
      searchParams.set("from", from);
    }
    if (state.to) {
      const to = splitDateTime(state.to, "en", { month: "2-digit", day: "2-digit" }).date;
      searchParams.set("to", to);
    }
    if (state.from && state.to) {
      searchParams.set("date", "custom");
    }
    if ((_a = state.searchState) == null ? void 0 : _a.trim()) {
      searchParams.set("search", (_b = state.searchState) == null ? void 0 : _b.trim());
    }
    if (state.category) {
      searchParams.set("category", state.category);
    }
    const dest = !((_c = state.searchState) == null ? void 0 : _c.trim()) ? "explore" : "search";
    togglePopover(false);
    push(`/${locale}/${dest}?${searchParams.toString()}`);
  };
  const clearAll = () => {
    setState((prev) => __spreadProps(__spreadValues({}, prev), {
      category: "",
      from: void 0,
      to: void 0,
      search: "",
      searchState: "",
      showPopover: false
    }));
  };
  return /* @__PURE__ */ jsx(
    context_default.Provider,
    {
      value: __spreadProps(__spreadValues({}, state), {
        togglePopover,
        onSearch,
        setCategory,
        setDate,
        clearHistory,
        onSubmit,
        clearAll,
        isLoading: isFetching,
        events: events == null ? void 0 : events.items,
        total: events == null ? void 0 : events.total
      }),
      children
    }
  );
};
var provider_default = SearchProvider;

// src/components/layout/header/Desktop.tsx
import { useWindowScroll as useWindowScroll2 } from "@wbk/hooks";
import { twMerge as twMerge7 } from "tailwind-merge";
import { Link as Link5, useRouter as useRouter14 } from "@wbk/config";

// src/components/layout/header/submenu/index.tsx
import { MapIcon, MapOutlinedIcon } from "@wbk/svg";
import { Button as Button10 } from "@wbk/ui";
import { Link as Link4, useRouter as useRouter11, useTranslation as useTranslation17 } from "@wbk/config";

// src/components/common/LocalizationSwitcher.tsx
import { Button, Tabs, Typography as Typography3 } from "@wbk/ui";
import { WorldIcon, WorldOutlinedIcon } from "@wbk/svg";
import { useTranslation as useTranslation3 } from "@wbk/config";
import { twMerge as twMerge2 } from "tailwind-merge";

// src/components/ui/extensions/ThemeResponsivePopover.tsx
import { twMerge } from "tailwind-merge";
import { ResponsivePopover as BaseResponsivePopover } from "@wbk/ui";
import { jsx as jsx2 } from "react/jsx-runtime";
var ThemeResponsivePopover = (props) => {
  var _a, _b;
  return /* @__PURE__ */ jsx2(
    BaseResponsivePopover,
    __spreadProps(__spreadValues({}, props), {
      popover: __spreadProps(__spreadValues({}, props.popover), {
        className: twMerge(
          "bg-secondary/60 backdrop-blur-xl rounded-L border border-secondary",
          (_a = props.popover) == null ? void 0 : _a.className
        )
      }),
      sheet: __spreadProps(__spreadValues({}, props.sheet), {
        className: twMerge(
          "bg-secondary/60 backdrop-blur-xl rounded-L border border-secondary pb-8  [&_div]:bg-transparent",
          (_b = props.sheet) == null ? void 0 : _b.className
        )
      })
    })
  );
};
var ThemeResponsivePopover_default = ThemeResponsivePopover;

// src/components/common/CurrencyToggle.tsx
import { useCurrency } from "@wbk/currency";
import { ToggleGroup, Typography } from "@wbk/ui";
import { useTranslation } from "@wbk/config";
import { jsx as jsx3 } from "react/jsx-runtime";
var CurrencyToggle = ({ onClose }) => {
  const { currency, setCurrency, currencies } = useCurrency();
  const { t } = useTranslation("calendar_common");
  if (!currencies) {
    return null;
  }
  return /* @__PURE__ */ jsx3(
    ToggleGroup,
    {
      type: "single",
      value: currency.shortCode,
      label: /* @__PURE__ */ jsx3(Typography, { variant: "body-L", strong: true, children: t("calendar_common:currency") }),
      options: currencies.map((currency2) => {
        const code = currency2.shortCode;
        const countryCode = code.slice(0, 2);
        return {
          icon: currency2.svgPath ? /* @__PURE__ */ jsx3(
            "svg",
            {
              width: "24",
              height: "24",
              viewBox: currency2.svgViewbox,
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              className: "h-4 w-4 shrink-0",
              children: /* @__PURE__ */ jsx3("path", { fill: "currentColor", d: currency2.svgPath })
            }
          ) : /* @__PURE__ */ jsx3(
            "img",
            {
              className: "h-4 w-4 shrink-0 rounded-full object-cover",
              src: `https://wbk-assets.s3.me-south-1.amazonaws.com/flags/w80/${countryCode.toLowerCase()}.png`,
              alt: ""
            }
          ),
          text: /* @__PURE__ */ jsx3(Typography, { className: "line-clamp-1", children: currency2.name }),
          value: code,
          isSelected: currency2.shortCode === code
        };
      }),
      onChange: (val) => {
        if (val && val !== currency.shortCode) {
          setCurrency(val);
          onClose();
        }
      },
      groupClassName: "gap-4 grid grid-cols-2",
      className: "[&>div]:grow",
      btnProps: {
        shape: "outlined",
        theme: "primary",
        className: "max-w-full py-4",
        phill: true
      },
      activeBtnProps: {
        shape: "outlined",
        className: "max-w-full py-4",
        phill: true
      }
    }
  );
};
var CurrencyToggle_default = CurrencyToggle;

// src/components/common/LanguageToggle.tsx
import { ToggleGroup as ToggleGroup2, Typography as Typography2 } from "@wbk/ui";
import { useRouter as useRouter2, useTranslation as useTranslation2 } from "@wbk/config";
import { CheckIcon } from "@wbk/svg";
import { jsx as jsx4 } from "react/jsx-runtime";
var LanguageToggle = () => {
  const { locale, setLocale, languages } = useRouter2();
  const { t } = useTranslation2("calendar_common");
  return /* @__PURE__ */ jsx4(
    ToggleGroup2,
    {
      type: "single",
      value: locale,
      label: /* @__PURE__ */ jsx4(Typography2, { variant: "body-L", strong: true, children: t("calendar_common:language") }),
      options: [
        ...languages.map((lang) => ({
          text: t(`common:${lang}`),
          value: lang,
          isSelected: locale === lang,
          icon: locale === lang ? /* @__PURE__ */ jsx4(CheckIcon, { className: "h-6 w-6 shrink-0" }) : null
        })),
        {
          text: t("common:zh_coming_soon"),
          value: "zh",
          disabled: true
        }
      ],
      onChange: (val) => __async(void 0, null, function* () {
        if (val && val !== locale) {
          yield setLocale(val);
          close();
        }
      }),
      groupClassName: "gap-4 grid grid-cols-2",
      className: "[&>div]:grow",
      btnProps: {
        shape: "outlined",
        theme: "primary",
        className: "max-w-full py-4",
        phill: true
      },
      activeBtnProps: {
        shape: "outlined",
        className: "max-w-full py-4",
        phill: true
      }
    }
  );
};
var LanguageToggle_default = LanguageToggle;

// src/components/common/LocalizationSwitcher.tsx
import { jsx as jsx5, jsxs } from "react/jsx-runtime";
var LocalizationSwitcher = ({ render }) => {
  const { t } = useTranslation3("calendar_common");
  return /* @__PURE__ */ jsx5(
    ThemeResponsivePopover_default,
    {
      popover: {
        className: "w-[400px] max-w-full",
        align: "end",
        sideOffset: 35,
        alignOffset: -15,
        cancel: {
          className: "bg-transparent text-primary font-bold"
        },
        action: {
          className: "bg-primary text-secondary rounded-full px-L py-S font-bold"
        }
      },
      sheet: {
        ignoreHistory: true,
        action: false,
        cancel: false
      },
      render: (props) => {
        if (render) {
          return render(props);
        }
        return /* @__PURE__ */ jsxs(
          Button,
          {
            shape: "text",
            theme: "secondary",
            className: "group peer bg-transparent px-2",
            onClick: props.open,
            "aria-label": t("calendar_common:language"),
            children: [
              /* @__PURE__ */ jsx5(
                WorldOutlinedIcon,
                {
                  "data-active": props.isOpen,
                  className: "h-6 w-6 shrink-0 data-[active=true]:hidden"
                }
              ),
              /* @__PURE__ */ jsx5(
                WorldIcon,
                {
                  "data-active": props.isOpen,
                  className: "hidden h-6 w-6 shrink-0 data-[active=true]:block"
                }
              )
            ]
          }
        );
      },
      body: ({ close: close2 }) => /* @__PURE__ */ jsx5(Body, { close: close2 })
    }
  );
};
var Body = ({ close: close2, className }) => {
  const { t } = useTranslation3("calendar_common");
  const tabs = [
    {
      label: /* @__PURE__ */ jsx5(Typography3, { variant: "body-L", strong: true, children: t("calendar_common:language") }),
      value: "language",
      content: /* @__PURE__ */ jsx5(LanguageToggle_default, {}),
      buttonProps: {
        className: "p-6 text-primary rounded-L border-none shrink-0 data-[state=active]:bg-primary data-[state=active]:text-secondary"
      }
    },
    {
      label: /* @__PURE__ */ jsx5(Typography3, { variant: "body-L", strong: true, children: t("calendar_common:currency") }),
      value: "currency",
      content: /* @__PURE__ */ jsx5(CurrencyToggle_default, { onClose: close2 }),
      buttonProps: {
        className: "p-6 text-primary rounded-L border-none shrink-0 data-[state=active]:bg-primary data-[state=active]:text-secondary"
      }
    }
  ];
  return /* @__PURE__ */ jsx5("div", { className: twMerge2("w-full space-y-4", className), children: /* @__PURE__ */ jsx5(
    Tabs,
    {
      className: "pb-S gap-S flex items-center border-b-transparent",
      defaultValue: "language",
      tabs
    }
  ) });
};
var LocalizationSwitcher_default = LocalizationSwitcher;

// src/components/favorites/FavoritesNav.tsx
import { useState as useState3 } from "react";
import { Button as Button5 } from "@wbk/ui";
import { Heart, HeartOutlined } from "@wbk/svg";
import { useDeviceDetect } from "@wbk/hooks";
import { useTranslation as useTranslation7 } from "@wbk/config";

// src/components/ui/extensions/ThemeBottomSheet.tsx
import { twMerge as twMerge3 } from "tailwind-merge";
import { BottomSheet as BaseBottomSheet } from "@wbk/ui";
import { jsx as jsx6 } from "react/jsx-runtime";
var ThemeBottomSheet = (_a) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx6(
    BaseBottomSheet,
    __spreadProps(__spreadValues({}, props), {
      className: twMerge3(
        "bg-secondary/60 rounded-L border-secondary [&_header>div]:after:bg-body-level-4 mx-auto mb-4 w-[95%] border backdrop-blur-xl [&_footer]:bg-transparent [&_header>div]:bg-transparent [&_header]:bg-transparent",
        className
      )
    })
  );
};
var ThemeBottomSheet_default = ThemeBottomSheet;

// src/components/favorites/FavoritesNavBody.tsx
import { Tabs as Tabs2, Typography as Typography7 } from "@wbk/ui";
import { useTranslation as useTranslation6 } from "@wbk/config";

// src/context/itinerary/provider.tsx
import { useEffect, useState as useState2 } from "react";
import { jsx as jsx7 } from "react/jsx-runtime";
var searchTimeout;
var createDefaultItinerary = () => {
  const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
  const from = new Date(currentYear, 0, 1);
  const to = new Date(currentYear, 11, 31);
  const days = [];
  const currentDate = new Date(from);
  while (currentDate <= to) {
    days.push({
      id: new Date(currentDate),
      events: []
    });
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return {
    id: `default-year-${currentYear}`,
    name: `${currentYear} Itinerary`,
    date: { from, to },
    days,
    created_at: /* @__PURE__ */ new Date()
  };
};
var ItineraryProvider = ({ children, id }) => {
  const [state, setState] = useState2({
    search: "",
    selectedEvents: []
  });
  const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
  const [itineraries, setItineraries] = useState2(() => {
    const stored = localStorage.getItem("itineraries");
    if (!stored || !stored.includes(`default-year-${currentYear}`)) {
      const defaultItinerary = createDefaultItinerary();
      const existingItineraries = stored ? JSON.parse(stored) : [];
      const updatedItineraries = [defaultItinerary, ...existingItineraries];
      localStorage.setItem("itineraries", JSON.stringify(updatedItineraries));
      return updatedItineraries;
    }
    const parsed = JSON.parse(stored);
    return parsed.map((itinerary) => {
      var _a;
      return __spreadProps(__spreadValues({}, itinerary), {
        date: {
          from: new Date(itinerary.date.from),
          to: new Date(itinerary.date.to)
        },
        days: (_a = itinerary.days) == null ? void 0 : _a.map((day) => __spreadProps(__spreadValues({}, day), {
          id: new Date(day.id)
        }))
      });
    });
  });
  const [mode, setMode] = useState2("summary");
  const [activeDay, setActiveDay] = useState2(null);
  const saveToLocalStorage = (updatedItineraries) => {
    setItineraries(updatedItineraries);
    localStorage.setItem("itineraries", JSON.stringify(updatedItineraries));
  };
  const addItinerary = (newItinerary) => {
    const newEntry = __spreadProps(__spreadValues({}, newItinerary), {
      created_at: /* @__PURE__ */ new Date()
    });
    const updatedItineraries = [...itineraries, newEntry];
    saveToLocalStorage(updatedItineraries);
  };
  const getItinerary = (id2) => {
    return itineraries.find((itinerary) => itinerary.id === id2);
  };
  const deleteItinerary = (id2) => {
    const updatedItineraries = itineraries.filter((itinerary) => itinerary.id !== id2);
    saveToLocalStorage(updatedItineraries);
  };
  const toggleEventSelection = (itineraryId, dayId, eventSlug) => {
    var _a;
    const isSelectedInTemp = state.selectedEvents.includes(eventSlug);
    const itinerary = getItinerary(itineraryId);
    const day = (_a = itinerary == null ? void 0 : itinerary.days) == null ? void 0 : _a.find((day2) => day2.id.toISOString() === dayId.toISOString());
    const isInStorage = day == null ? void 0 : day.events.some((slug) => slug === eventSlug);
    if (isSelectedInTemp || isInStorage) {
      setState((prev) => __spreadProps(__spreadValues({}, prev), {
        selectedEvents: prev.selectedEvents.filter((slug) => slug !== eventSlug)
      }));
      if (isInStorage) {
        const updatedItineraries = itineraries.map((itinerary2) => {
          var _a2;
          if (itinerary2.id !== itineraryId)
            return itinerary2;
          return __spreadProps(__spreadValues({}, itinerary2), {
            days: (_a2 = itinerary2.days) == null ? void 0 : _a2.map((day2) => {
              if (day2.id.toISOString() !== dayId.toISOString())
                return day2;
              return __spreadProps(__spreadValues({}, day2), {
                events: day2.events.filter((slug) => slug !== eventSlug)
              });
            })
          });
        });
        saveToLocalStorage(updatedItineraries);
      }
    } else {
      setState((prev) => __spreadProps(__spreadValues({}, prev), { selectedEvents: [...prev.selectedEvents, eventSlug] }));
    }
  };
  const cancelSelection = () => {
    setState((prev) => __spreadProps(__spreadValues({}, prev), { selectedEvents: [] }));
  };
  const confirmSelection = (itineraryId, dayId) => {
    const updatedList = itineraries.map((itinerary) => {
      var _a;
      if (itinerary.id !== itineraryId)
        return itinerary;
      return __spreadProps(__spreadValues({}, itinerary), {
        days: (_a = itinerary.days) == null ? void 0 : _a.map((day) => {
          if (day.id.toISOString() !== dayId.toISOString())
            return day;
          return __spreadProps(__spreadValues({}, day), {
            events: [.../* @__PURE__ */ new Set([...day.events, ...state.selectedEvents])]
            // Avoid duplicates
          });
        })
      });
    });
    saveToLocalStorage(updatedList);
    setState((prev) => __spreadProps(__spreadValues({}, prev), { selectedEvents: [] }));
  };
  const handleSearch = (value) => {
    const searchValue = value || "";
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      setState((prev) => __spreadProps(__spreadValues({}, prev), { search: searchValue }));
    }, 500);
  };
  const isEventInDay = (itineraryId, dayId, eventSlug) => {
    var _a;
    const itinerary = getItinerary(itineraryId);
    const day = (_a = itinerary == null ? void 0 : itinerary.days) == null ? void 0 : _a.find((day2) => day2.id.toISOString() === dayId.toISOString());
    return state.selectedEvents.includes(eventSlug) || !!(day == null ? void 0 : day.events.some((slug) => slug === eventSlug));
  };
  const normalizeDate = (date) => {
    const normalized = new Date(date);
    normalized.setHours(0, 0, 0, 0);
    return normalized;
  };
  const updateItinerary = (id2, updatedData) => {
    const itinerary = itineraries.find((itinerary2) => itinerary2.id === id2);
    if (!itinerary)
      return;
    const { name, date } = updatedData;
    const oldDays = itinerary.days || [];
    const newDays = [];
    if (date) {
      const currentDate = normalizeDate(new Date(date.from));
      while (currentDate <= date.to) {
        const existingDay = oldDays.find(
          (day) => normalizeDate(day.id).toISOString() === currentDate.toISOString()
        );
        newDays.push(
          existingDay || {
            id: normalizeDate(new Date(currentDate)),
            events: []
          }
        );
        currentDate.setDate(currentDate.getDate() + 1);
      }
    }
    const updatedItinerary = __spreadProps(__spreadValues({}, itinerary), {
      name: name || itinerary.name,
      date: date || itinerary.date,
      days: newDays
    });
    const updatedList = itineraries.map(
      (itinerary2) => itinerary2.id === id2 ? updatedItinerary : itinerary2
    );
    saveToLocalStorage(updatedList);
  };
  const reorderEvents = (itineraryId, updates) => {
    var _a;
    const itinerary = itineraries.find((i) => i.id === itineraryId);
    if (!itinerary)
      return;
    const updatedDays = (_a = itinerary.days) == null ? void 0 : _a.map(
      (day) => updates[day.id.toISOString()] ? __spreadProps(__spreadValues({}, day), { events: updates[day.id.toISOString()] }) : day
    );
    const updatedItinerary = __spreadProps(__spreadValues({}, itinerary), { days: updatedDays });
    saveToLocalStorage(itineraries.map((i) => i.id === itineraryId ? updatedItinerary : i));
  };
  useEffect(() => {
    const now = /* @__PURE__ */ new Date();
    const sixMonthsAgo = /* @__PURE__ */ new Date();
    sixMonthsAgo.setMonth(now.getMonth() - 6);
    const cleanedItineraries = itineraries.filter((itinerary) => {
      var _a;
      const notOld = new Date(itinerary.created_at) > sixMonthsAgo;
      const hasEvents = !!((_a = itinerary.days) == null ? void 0 : _a.length);
      return notOld && hasEvents;
    });
    saveToLocalStorage(cleanedItineraries);
  }, []);
  return /* @__PURE__ */ jsx7(
    context_default2.Provider,
    {
      value: __spreadProps(__spreadValues({}, state), {
        id,
        itineraries,
        addItinerary,
        getItinerary,
        deleteItinerary,
        mode,
        setMode,
        activeDay,
        setActiveDay,
        handleSearch,
        toggleEventSelection,
        cancelSelection,
        confirmSelection,
        isEventInDay,
        updateItinerary,
        reorderEvents
      }),
      children
    }
  );
};
var provider_default2 = ItineraryProvider;

// src/components/favorites/FavoritesContent.tsx
import { Button as Button2, Divider, Typography as Typography4 } from "@wbk/ui";
import { ArrowIcon, BrokenHeart } from "@wbk/svg";
import { Link, useRouter as useRouter3, useTranslation as useTranslation4 } from "@wbk/config";
import { Fragment, jsx as jsx8, jsxs as jsxs2 } from "react/jsx-runtime";
var FavoritesContent = ({ close: close2 }) => {
  const { locale } = useRouter3();
  const { t } = useTranslation4("calendar_common");
  const { favorites } = useFavorites();
  const { data, isLoading, error } = useGetEventsList({
    lang: locale,
    where: { slug_in: favorites },
    limit: 3
  });
  if (error) {
    return null;
  }
  return /* @__PURE__ */ jsxs2(Fragment, { children: [
    /* @__PURE__ */ jsx8("div", { className: "space-y-2 p-4", children: isLoading ? /* @__PURE__ */ jsxs2(Fragment, { children: [
      /* @__PURE__ */ jsx8("div", { className: "bg-body-level-2 h-[120px] animate-pulse rounded-md" }),
      /* @__PURE__ */ jsx8("div", { className: "bg-body-level-2 h-[120px] animate-pulse rounded-md" }),
      /* @__PURE__ */ jsx8("div", { className: "bg-body-level-2 h-[120px] animate-pulse rounded-md" })
    ] }) : data && (data == null ? void 0 : data.items.length) > 0 ? data == null ? void 0 : data.items.map((event) => /* @__PURE__ */ jsx8(ListItem_default, { event, onClick: close2 }, event.id)) : /* @__PURE__ */ jsxs2("div", { className: "flex w-full flex-col items-center justify-center gap-5 p-10 text-center", children: [
      /* @__PURE__ */ jsx8(BrokenHeart, { className: "bg-body-level-2 text-primary h-20 w-20 rounded-full p-5" }),
      /* @__PURE__ */ jsxs2("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx8(Typography4, { variant: "label-L", children: t("calendar_common:favorites.empty") }),
        /* @__PURE__ */ jsx8(Typography4, { variant: "body-S", color: "primary", children: t("calendar_common:favorites.how_to_add_favorites_description") })
      ] }),
      /* @__PURE__ */ jsx8(ThemeButton_default, { as: Link, to: `/${locale}/explore`, onClick: close2, children: /* @__PURE__ */ jsx8(Typography4, { variant: "heading-XS", strong: true, className: "px-S py-XXS", children: t("calendar_common:favorites.explore_more") }) })
    ] }) }),
    data && (data == null ? void 0 : data.items.length) > 0 && /* @__PURE__ */ jsxs2("div", { className: "px-4", children: [
      /* @__PURE__ */ jsx8(Divider, { className: "border-primary/30" }),
      /* @__PURE__ */ jsx8(ActionButton, { onClick: close2 })
    ] })
  ] });
};
var ActionButton = ({ onClick }) => {
  const { favorites } = useFavorites();
  const { locale } = useRouter3();
  const { t } = useTranslation4("calendar_common");
  return /* @__PURE__ */ jsx8(
    Button2,
    {
      as: Link,
      to: `/${locale}/favorites`,
      shape: "text",
      className: "text-text w-full justify-start p-0 py-4 text-start",
      onClick,
      children: /* @__PURE__ */ jsxs2("div", { className: "flex w-full items-center justify-between", children: [
        /* @__PURE__ */ jsx8(Typography4, { strong: true, children: t("calendar_common:favorites.open_favorites_total", { count: favorites.length }) }),
        /* @__PURE__ */ jsx8(ArrowIcon, { className: "ltr:rotate-180" })
      ] })
    }
  );
};
var FavoritesContent_default = FavoritesContent;

// src/components/favorites/ItineraryContent.tsx
import { Button as Button4, Divider as Divider2, Typography as Typography6 } from "@wbk/ui";
import { Link as Link3, useRouter as useRouter5, useTranslation as useTranslation5 } from "@wbk/config";
import { ArrowIcon as ArrowIcon2, BrokenHeart as BrokenHeart2 } from "@wbk/svg";

// src/components/itinerary/ListItem.tsx
import { twMerge as twMerge4 } from "tailwind-merge";
import { Link as Link2, useRouter as useRouter4 } from "@wbk/config";
import { Button as Button3, ImageWithPlaceholder, Typography as Typography5 } from "@wbk/ui";
import { formatDate } from "@wbk/utils";
import { jsx as jsx9, jsxs as jsxs3 } from "react/jsx-runtime";
var ItineraryListItem = ({ events, itinerary, onClick }) => {
  var _a;
  const { locale } = useRouter4();
  return /* @__PURE__ */ jsxs3(
    Button3,
    {
      href: `/${locale}/itinerary/view/${itinerary.id}`,
      as: Link2,
      className: twMerge4("text-text flex w-full items-center gap-3 bg-transparent p-0 text-start"),
      shape: "text",
      "data-testid": `itinerary_list_item_${itinerary.id}`,
      onClick,
      children: [
        /* @__PURE__ */ jsx9("div", { className: "aspect-1 rounded-S h-[96px] w-full max-w-[96px] overflow-hidden", children: !events.length ? /* @__PURE__ */ jsx9(ImageWithPlaceholder, { className: "aspect-1", width: 96, height: 96 }) : events.length >= 4 ? /* @__PURE__ */ jsx9("div", { className: "grid grid-cols-2", children: events.slice(0, 4).map((event, i) => /* @__PURE__ */ jsx9(
          ContentfulMedia_default,
          {
            className: "aspect-1 h-full w-full shrink-0 object-cover",
            media: event.image11,
            ratio: "1x1",
            fit: "thumb",
            placeholder: true
          },
          i
        )) }) : /* @__PURE__ */ jsx9(
          ContentfulMedia_default,
          {
            className: "aspect-1 h-[96px] w-[96px] shrink-0 object-cover",
            media: events[0].image11,
            width: 96,
            height: 96,
            ratio: "1x1",
            fit: "thumb",
            placeholder: true
          }
        ) }),
        /* @__PURE__ */ jsxs3("div", { className: "w-full space-y-1 py-1", children: [
          /* @__PURE__ */ jsx9("div", { className: "flex items-start justify-between", children: /* @__PURE__ */ jsx9(LineClamp_default, { variant: "heading-XS", className: "line-clamp-2", children: itinerary.name }) }),
          itinerary.days && ((_a = itinerary.days) == null ? void 0 : _a.length) > 0 && /* @__PURE__ */ jsxs3(Typography5, { variant: "body-S", className: "text-text-secondary line-clamp-1", children: [
            formatDate(itinerary.days[0].id, locale, {
              month: "short",
              day: "2-digit"
            }),
            /* @__PURE__ */ jsx9("span", { className: "px-2", children: "-" }),
            formatDate(itinerary.days[itinerary.days.length - 1].id, locale, {
              month: "short",
              day: "2-digit"
            })
          ] })
        ] })
      ]
    }
  );
};
var ListItem_default2 = ItineraryListItem;

// src/components/favorites/ItineraryContent.tsx
import { Fragment as Fragment2, jsx as jsx10, jsxs as jsxs4 } from "react/jsx-runtime";
var ItineraryContent = ({ close: close2 }) => {
  const { locale } = useRouter5();
  const { t } = useTranslation5("calendar_common");
  const { itineraries } = useItinerary();
  const slugs = Array.from(
    new Set(itineraries.flatMap((itinerary) => {
      var _a;
      return ((_a = itinerary == null ? void 0 : itinerary.days) == null ? void 0 : _a.flatMap((day) => day.events)) || [];
    }))
  );
  const {
    data: events,
    isLoading,
    error
  } = useGetEventsList({
    lang: locale,
    where: { slug_in: slugs },
    limit: 50
  });
  const eventsByItinerary = itineraries.reduce(
    (acc, itinerary) => {
      var _a;
      const itineraryEvents = (_a = itinerary.days) == null ? void 0 : _a.flatMap(
        (day) => day.events.map((slug) => events == null ? void 0 : events.items.find((event) => event.slug === slug)).filter((event) => !!event)
      );
      acc[itinerary.id] = itineraryEvents || [];
      return acc;
    },
    {}
  );
  if (error) {
    return null;
  }
  return /* @__PURE__ */ jsxs4(Fragment2, { children: [
    /* @__PURE__ */ jsx10("div", { className: "space-y-2 p-4", children: isLoading ? /* @__PURE__ */ jsxs4(Fragment2, { children: [
      /* @__PURE__ */ jsx10("div", { className: "bg-body-level-2 h-[120px] animate-pulse rounded-md" }),
      /* @__PURE__ */ jsx10("div", { className: "bg-body-level-2 h-[120px] animate-pulse rounded-md" }),
      /* @__PURE__ */ jsx10("div", { className: "bg-body-level-2 h-[120px] animate-pulse rounded-md" })
    ] }) : itineraries && itineraries.length > 0 ? itineraries.slice(0, 3).map((item, i) => {
      const itineraryEvents = eventsByItinerary[item.id];
      return /* @__PURE__ */ jsx10("div", { className: "space-y-2", children: /* @__PURE__ */ jsx10(
        ListItem_default2,
        {
          itinerary: item,
          events: itineraryEvents.slice(0, 4),
          onClick: close2
        }
      ) }, i);
    }) : /* @__PURE__ */ jsxs4("div", { className: "flex w-full flex-col items-center justify-center gap-5 pb-10 pt-5 text-center", children: [
      /* @__PURE__ */ jsx10(BrokenHeart2, { className: "bg-body-level-2 text-primary h-14 w-14 rounded-full p-2" }),
      /* @__PURE__ */ jsx10("div", { className: "space-y-1", children: /* @__PURE__ */ jsx10(Typography6, { variant: "label-L", children: t("calendar_common:itinerary.empty") }) }),
      /* @__PURE__ */ jsx10(ThemeButton_default, { as: Link3, to: `/${locale}/itinerary`, onClick: close2, children: t("calendar_common:itinerary.add_itinerary") })
    ] }) }),
    itineraries && itineraries.length > 0 && /* @__PURE__ */ jsxs4("div", { className: "px-4", children: [
      /* @__PURE__ */ jsx10(Divider2, { className: "border-primary/30" }),
      /* @__PURE__ */ jsx10(ActionButton2, { onClick: close2 })
    ] })
  ] });
};
var ActionButton2 = ({ onClick }) => {
  const { itineraries } = useItinerary();
  const { locale } = useRouter5();
  const { t } = useTranslation5("calendar_common");
  return /* @__PURE__ */ jsx10(
    Button4,
    {
      as: Link3,
      to: `/${locale}/favorites`,
      shape: "text",
      className: "text-text w-full justify-start p-0 py-4 text-start",
      onClick,
      children: /* @__PURE__ */ jsxs4("div", { className: "flex w-full items-center justify-between", children: [
        /* @__PURE__ */ jsx10(Typography6, { strong: true, children: t("calendar_common:itinerary.open_itineraries_total", { count: itineraries.length }) }),
        /* @__PURE__ */ jsx10(ArrowIcon2, { className: "ltr:rotate-180" })
      ] })
    }
  );
};
var ItineraryContent_default = ItineraryContent;

// src/components/favorites/FavoritesNavBody.tsx
import { jsx as jsx11 } from "react/jsx-runtime";
var FavoritesNavBody = ({ close: close2 }) => {
  const { t } = useTranslation6("calendar_common");
  const tabs = [
    {
      label: /* @__PURE__ */ jsx11(Typography7, { variant: "body-L", strong: true, children: t("calendar_common:favorites.favorite") }),
      value: "favorite",
      content: /* @__PURE__ */ jsx11(FavoritesContent_default, { close: close2 }),
      buttonProps: {
        className: "p-6 text-primary rounded-L border-none shrink-0 data-[state=active]:bg-primary data-[state=active]:text-secondary"
      }
    },
    {
      label: /* @__PURE__ */ jsx11(Typography7, { variant: "body-L", strong: true, children: t("calendar_common:itinerary.trips") }),
      value: "trips",
      content: /* @__PURE__ */ jsx11(provider_default2, { children: /* @__PURE__ */ jsx11(ItineraryContent_default, { close: close2 }) }),
      buttonProps: {
        className: "p-6 text-primary rounded-L border-none shrink-0 data-[state=active]:bg-primary data-[state=active]:text-secondary"
      }
    }
  ];
  return /* @__PURE__ */ jsx11(
    Tabs2,
    {
      className: "p-S gap-S flex items-center border-b-transparent bg-transparent",
      defaultValue: "favorite",
      tabs
    }
  );
};
var FavoritesNavBody_default = FavoritesNavBody;

// src/components/favorites/FavoritesNav.tsx
import { jsx as jsx12 } from "react/jsx-runtime";
var FavoritesNav = ({ isActive }) => {
  const { t } = useTranslation7("calendar_common");
  const [open, setOpen] = useState3(false);
  const { isMobile } = useDeviceDetect();
  return !isActive && !isMobile ? /* @__PURE__ */ jsx12(
    ThemePopover_default,
    {
      open,
      onOpenChange: setOpen,
      sideOffset: 35,
      alignOffset: -15,
      align: "end",
      className: "w-80 max-w-full overflow-hidden sm:w-[400px] [&>div]:p-0",
      content: /* @__PURE__ */ jsx12(FavoritesNavBody_default, { close: () => setOpen(false) }),
      children: /* @__PURE__ */ jsx12(
        Button5,
        {
          shape: "text",
          theme: "secondary",
          className: "peer px-2",
          "aria-label": t("calendar_common:favorites.title"),
          children: open ? /* @__PURE__ */ jsx12(Heart, { "data-active": open, className: "h-6 w-6 shrink-0" }) : /* @__PURE__ */ jsx12(HeartOutlined, { className: "h-6 w-6 shrink-0" })
        }
      )
    }
  ) : !isActive && isMobile ? /* @__PURE__ */ jsx12(
    ThemeBottomSheet_default,
    {
      ignoreHistory: true,
      closeButton: true,
      className: "bg-body pb-2",
      render: ({ open: open2 }) => /* @__PURE__ */ jsx12(
        Button5,
        {
          onClick: open2,
          shape: "text",
          theme: "secondary",
          className: "peer px-2",
          "aria-label": t("calendar_common:favorites.title"),
          children: /* @__PURE__ */ jsx12(HeartOutlined, { className: "h-6 w-6 shrink-0" })
        }
      ),
      body: ({ close: close2 }) => /* @__PURE__ */ jsx12(FavoritesNavBody_default, { close: close2 })
    }
  ) : /* @__PURE__ */ jsx12(
    Button5,
    {
      shape: "text",
      theme: "secondary",
      className: "peer px-2",
      "aria-label": t("calendar_common:favorites.title"),
      children: /* @__PURE__ */ jsx12(Heart, { className: "h-6 w-6 shrink-0" })
    }
  );
};
var FavoritesNav_default = FavoritesNav;

// src/components/layout/header/search/mobile/index.tsx
import { Button as Button9, Modal } from "@wbk/ui";
import { SearchIcon as SearchIcon3 } from "@wbk/svg";
import { useWindowResize } from "@wbk/hooks";
import { useTranslation as useTranslation15 } from "@wbk/config";

// src/components/layout/header/search/mobile/Content.tsx
import { Button as Button8 } from "@wbk/ui";
import { useRouter as useRouter9, useTranslation as useTranslation14 } from "@wbk/config";
import { ChevronIcon as ChevronIcon2, SearchIcon as SearchIcon2 } from "@wbk/svg";

// src/components/layout/header/search/desktop/Content.tsx
import { Typography as Typography11 } from "@wbk/ui";
import { useTranslation as useTranslation11 } from "@wbk/config";

// src/components/search/EmptyResult.tsx
import { useTranslation as useTranslation9 } from "@wbk/config";
import { SearchIcon } from "@wbk/svg";
import { Typography as Typography9 } from "@wbk/ui";

// src/components/search/FeaturedEvents.tsx
import { Typography as Typography8 } from "@wbk/ui";
import { useRouter as useRouter6, useTranslation as useTranslation8 } from "@wbk/config";
import { jsx as jsx13, jsxs as jsxs5 } from "react/jsx-runtime";
var SearchFeaturedEvents = () => {
  const { togglePopover } = useSearch();
  const { t } = useTranslation8("calendar_common");
  const { locale } = useRouter6();
  const { data, isLoading } = useGetEventsList(
    {
      lang: locale,
      limit: 4,
      where: { featured: true }
    },
    { staleTime: Infinity }
  );
  const events = data == null ? void 0 : data.items;
  return /* @__PURE__ */ jsxs5("div", { className: "space-y-6 py-4", children: [
    /* @__PURE__ */ jsx13(Typography8, { variant: "heading-XS", children: t("calendar_common:most_searched") }),
    isLoading ? /* @__PURE__ */ jsxs5("div", { className: "space-y-4", children: [
      /* @__PURE__ */ jsx13("div", { className: "bg-body-level-1 h-28 rounded-md" }),
      /* @__PURE__ */ jsx13("div", { className: "bg-body-level-1 h-28 rounded-md" }),
      /* @__PURE__ */ jsx13("div", { className: "bg-body-level-1 h-28 rounded-md" })
    ] }) : (events == null ? void 0 : events.length) ? /* @__PURE__ */ jsx13("ul", { className: "space-y-4", children: events == null ? void 0 : events.map((event, i) => /* @__PURE__ */ jsx13(
      "li",
      {
        className: "flex items-center gap-2 [&>a>img]:min-h-20 [&>a>img]:min-w-20",
        children: /* @__PURE__ */ jsx13(ListItem_default, { event, onClick: () => togglePopover(false) })
      },
      event.slug + i
    )) }) : null
  ] });
};
var FeaturedEvents_default = SearchFeaturedEvents;

// src/components/search/EmptyResult.tsx
import { Fragment as Fragment3, jsx as jsx14, jsxs as jsxs6 } from "react/jsx-runtime";
var EmptySearchResult = () => {
  const { t } = useTranslation9("calendar_common");
  const { searchState } = useSearch();
  return /* @__PURE__ */ jsxs6(Fragment3, { children: [
    /* @__PURE__ */ jsxs6("div", { className: "space-y-4", children: [
      /* @__PURE__ */ jsx14("div", { className: "bg-body-level-1 mx-auto flex h-20 w-20 items-center justify-center space-y-4 rounded-full text-center", children: /* @__PURE__ */ jsx14(SearchIcon, { className: "h-10 w-10 shrink-0" }) }),
      /* @__PURE__ */ jsxs6("div", { className: "space-y-1 text-center", children: [
        /* @__PURE__ */ jsx14(Typography9, { variant: "label-L", children: t("calendar_common:empty_search", { search: searchState }) }),
        /* @__PURE__ */ jsx14(Typography9, { variant: "body-S", color: "text-secondary", children: t("calendar_common:empty_search_description") })
      ] })
    ] }),
    /* @__PURE__ */ jsx14(FeaturedEvents_default, {})
  ] });
};
var EmptyResult_default = EmptySearchResult;

// src/components/search/InitialScreen.tsx
import { useTranslation as useTranslation10 } from "@wbk/config";
import { Divider as Divider3, Typography as Typography10 } from "@wbk/ui";
import { ArrowBackIcon } from "@wbk/svg";
import { Fragment as Fragment4, jsx as jsx15, jsxs as jsxs7 } from "react/jsx-runtime";
var SearchInitialScreen = () => {
  const { t } = useTranslation10("calendar_common");
  const { searchHistory, clearHistory, onSearch } = useSearch();
  return /* @__PURE__ */ jsxs7(Fragment4, { children: [
    searchHistory.length > 0 && /* @__PURE__ */ jsxs7("div", { className: "space-y-6", children: [
      /* @__PURE__ */ jsxs7("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ jsx15(Typography10, { variant: "heading-XS", children: t("calendar_common:recent_searches") }),
        /* @__PURE__ */ jsx15(
          ThemeButton_default,
          {
            "data-testid": "header_search_clear_history",
            onClick: clearHistory,
            shape: "text",
            className: "py-1",
            children: /* @__PURE__ */ jsx15(Typography10, { variant: "label-S", children: t("calendar_common:clear_all") })
          }
        )
      ] }),
      /* @__PURE__ */ jsx15("ul", { className: "flex flex-wrap gap-2", children: searchHistory.map((term, i) => /* @__PURE__ */ jsx15("li", { children: /* @__PURE__ */ jsxs7(
        ThemeButton_default,
        {
          "data-testid": `header_search_history_button_${term}`,
          onClick: () => onSearch(term),
          theme: "white",
          shape: "outlined",
          className: "border-paper gap-2 p-2",
          children: [
            /* @__PURE__ */ jsx15(ArrowBackIcon, { className: "h-4 w-4 shrink-0" }),
            /* @__PURE__ */ jsx15(Typography10, { variant: "label-S", children: term })
          ]
        }
      ) }, i)) }),
      /* @__PURE__ */ jsx15(Divider3, { className: "border-body-level-4 pb-4" })
    ] }),
    /* @__PURE__ */ jsx15(FeaturedEvents_default, {})
  ] });
};
var InitialScreen_default = SearchInitialScreen;

// src/components/layout/header/search/desktop/Content.tsx
import { Fragment as Fragment5, jsx as jsx16, jsxs as jsxs8 } from "react/jsx-runtime";
var SearchContent = () => {
  const { events, search, searchState, isLoading, togglePopover } = useSearch();
  const { t } = useTranslation11("calendar_common");
  return /* @__PURE__ */ jsx16(Fragment5, { children: isLoading ? /* @__PURE__ */ jsxs8("div", { className: "space-y-4", children: [
    /* @__PURE__ */ jsx16("div", { className: "bg-body-level-1 h-20 animate-pulse rounded-md" }),
    /* @__PURE__ */ jsx16("div", { className: "bg-body-level-1 h-20 animate-pulse rounded-md" })
  ] }) : !!searchState && (events == null ? void 0 : events.length) ? /* @__PURE__ */ jsxs8("div", { className: "space-y-4", children: [
    /* @__PURE__ */ jsx16(Typography11, { variant: "heading-XS", children: t("calendar_common:search_results_for", { search: searchState }) }),
    /* @__PURE__ */ jsx16("ul", { className: "space-y-4", children: events.map((event, i) => /* @__PURE__ */ jsx16(
      "li",
      {
        className: "flex items-center gap-2 [&>a>img]:min-h-20 [&>a>img]:min-w-20",
        children: /* @__PURE__ */ jsx16(ListItem_default, { event, onClick: () => togglePopover(false) })
      },
      event.slug + i
    )) })
  ] }) : search ? /* @__PURE__ */ jsx16(EmptyResult_default, {}) : /* @__PURE__ */ jsx16(InitialScreen_default, {}) });
};
var Content_default = SearchContent;

// src/components/ui/extensions/ThemeInput.tsx
import { twMerge as twMerge5 } from "tailwind-merge";
import { Input as BaseInput } from "@wbk/ui";
import { jsx as jsx17 } from "react/jsx-runtime";
var ThemeInput = (_a) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx17(
    BaseInput,
    __spreadProps(__spreadValues({}, props), {
      className: twMerge5(
        "bg-secondary/60 rounded-XL focus:bg-secondary/25 hover:bg-secondary/25 placeholder:text-primary text-body-S p-3 backdrop-blur-xl",
        className
      )
    })
  );
};
var ThemeInput_default = ThemeInput;

// src/components/layout/header/search/mobile/Category.tsx
import { ChevronIcon, FourSquares } from "@wbk/svg";
import { Button as Button6, ToggleGroup as ToggleGroup3, Typography as Typography12 } from "@wbk/ui";
import { useRouter as useRouter7, useTranslation as useTranslation12 } from "@wbk/config";
import { jsx as jsx18, jsxs as jsxs9 } from "react/jsx-runtime";
var SearchCategory = () => {
  const { t } = useTranslation12("calendar_common");
  const { category, setCategory } = useSearch();
  const { locale: lang } = useRouter7();
  const { data: categories } = useGetCategories({
    lang,
    limit: 20,
    where: { parent_exists: false }
  });
  return /* @__PURE__ */ jsx18(
    ThemeBottomSheet_default,
    {
      ignoreHistory: true,
      sectionClassName: "pb-28 px-6",
      stickyFooter: ({ close: close2 }) => /* @__PURE__ */ jsxs9("div", { className: "flex gap-2 bg-transparent px-6 py-4", children: [
        /* @__PURE__ */ jsx18(
          ThemeButton_default,
          {
            theme: "transparent",
            className: "h-12 flex-1",
            type: "button",
            onClick: () => {
              setCategory("");
              close2();
            },
            children: t("calendar_common:clear")
          }
        ),
        /* @__PURE__ */ jsx18(ThemeButton_default, { className: "h-12 flex-1", onClick: close2, children: t("calendar_common:apply") })
      ] }),
      body: () => /* @__PURE__ */ jsx18(Body2, { categories: categories || [] }),
      render: ({ open }) => {
        var _a;
        return /* @__PURE__ */ jsxs9(Button6, { theme: "action", onClick: open, className: "flex-1 bg-transparent", rounded: false, children: [
          /* @__PURE__ */ jsx18(Typography12, { as: "span", variant: "body-S", className: "line-clamp-1", children: category ? (_a = categories == null ? void 0 : categories.find((c) => c.slug === category)) == null ? void 0 : _a.title : t("calendar_common:everything") }),
          /* @__PURE__ */ jsx18(ChevronIcon, { className: "h-2 w-2 rotate-90" })
        ] });
      }
    }
  );
};
var Body2 = ({ categories }) => {
  const { category, setCategory } = useSearch();
  const { t } = useTranslation12("calendar_common");
  return /* @__PURE__ */ jsx18(
    ToggleGroup3,
    {
      type: "single",
      value: category,
      onChange: setCategory,
      groupClassName: "flex-col",
      className: "w-full max-w-full justify-start text-start",
      btnProps: { theme: "primary" },
      options: [
        {
          text: t("calendar_common:everything"),
          value: "",
          icon: /* @__PURE__ */ jsx18(FourSquares, { className: "h-5 w-5" })
        }
      ].concat(
        categories.map((cat) => ({
          text: cat.title,
          value: cat.slug,
          icon: /* @__PURE__ */ jsx18(
            ContentfulMedia_default,
            {
              media: cat.icon,
              "data-selected": category === cat.slug,
              className: "h-5 w-5 data-[selected=true]:invert"
            }
          )
        }))
      )
    }
  );
};
var Category_default = SearchCategory;

// src/components/layout/header/search/mobile/Date.tsx
import { useMemo } from "react";
import { Button as Button7, DayPicker, Typography as Typography13 } from "@wbk/ui";
import { formatDate as formatDate2, isSameDay } from "@wbk/utils";
import { useRouter as useRouter8, useTranslation as useTranslation13 } from "@wbk/config";
import { jsx as jsx19, jsxs as jsxs10 } from "react/jsx-runtime";
var DateSearch = () => {
  const { locale } = useRouter8();
  const { t } = useTranslation13("calendar_common");
  const { from, to, setDate } = useSearch();
  const date = useMemo(() => {
    if (from && to) {
      const sameDay = isSameDay(from, to);
      const formattedFrom = formatDate2(from, locale, {
        day: "2-digit",
        month: "short"
      });
      if (sameDay) {
        return formattedFrom;
      }
      const formattedTo = formatDate2(to, locale, {
        day: "2-digit",
        month: "short"
      });
      return `${formattedFrom} - ${formattedTo}`;
    }
    return t("calendar_common:any_time");
  }, [from, locale, t, to]);
  return /* @__PURE__ */ jsx19(
    ThemeBottomSheet_default,
    {
      ignoreHistory: true,
      sectionClassName: "pb-28 px-6",
      stickyFooter: ({ close: close2 }) => /* @__PURE__ */ jsxs10("div", { className: "flex gap-2 border-t px-6 py-4", children: [
        /* @__PURE__ */ jsx19(
          ThemeButton_default,
          {
            theme: "transparent",
            className: "h-12 flex-1",
            type: "button",
            onClick: () => {
              setDate(void 0, void 0);
              close2();
            },
            children: t("calendar_common:clear")
          }
        ),
        /* @__PURE__ */ jsx19(ThemeButton_default, { className: "h-12 flex-1", onClick: close2, children: t("calendar_common:apply") })
      ] }),
      body: () => /* @__PURE__ */ jsx19(Body3, {}),
      render: ({ open }) => {
        return /* @__PURE__ */ jsx19(Button7, { onClick: open, className: "flex-1", theme: "transparent", children: /* @__PURE__ */ jsx19(Typography13, { as: "span", variant: "body-S", children: date }) });
      }
    }
  );
};
var Body3 = () => {
  const { from, to, setDate } = useSearch();
  const { locale } = useRouter8();
  return /* @__PURE__ */ jsx19(
    DayPicker,
    {
      lang: locale,
      mode: "range",
      selected: { from, to },
      fromDate: /* @__PURE__ */ new Date(),
      defaultMonth: from,
      onSelect: (value) => {
        setDate(value == null ? void 0 : value.from, value == null ? void 0 : value.to);
      },
      components: {
        CaptionLabel: ({ displayMonth }) => {
          return /* @__PURE__ */ jsx19(Typography13, { className: "px-2", children: formatDate2(displayMonth, locale, { month: "long", year: "numeric" }) });
        }
      }
    }
  );
};
var Date_default = DateSearch;

// src/components/layout/header/search/mobile/Content.tsx
import { Fragment as Fragment6, jsx as jsx20, jsxs as jsxs11 } from "react/jsx-runtime";
var MobileSearchContent = () => {
  const { t } = useTranslation14("calendar_common");
  const { push } = useRouter9();
  const { locale } = useRouter9();
  const { searchState, onSearch, togglePopover } = useSearch();
  return /* @__PURE__ */ jsxs11(Fragment6, { children: [
    /* @__PURE__ */ jsxs11("header", { className: "sticky top-0 z-10 bg-transparent shadow-sm", children: [
      /* @__PURE__ */ jsxs11("div", { className: "flex flex-row-reverse items-center gap-2 px-4 py-2", children: [
        /* @__PURE__ */ jsx20(
          "form",
          {
            className: "relative grow",
            onSubmit: (event) => {
              event.preventDefault();
              if (searchState == null ? void 0 : searchState.trim()) {
                togglePopover(false);
                push(`/${locale}/search?search=${searchState}`);
              }
            },
            children: /* @__PURE__ */ jsx20(
              ThemeInput_default,
              {
                "data-testid": "header_mobile_search_input",
                type: "search",
                inputMode: "search",
                className: "!bg-body h-12 ltr:pl-9 rtl:pr-9",
                placeholder: t("calendar_common:search"),
                value: searchState || "",
                onChange: (value) => onSearch(value),
                startIcon: /* @__PURE__ */ jsx20(SearchIcon2, { className: "mx-2 h-full w-6 shrink-0 opacity-70" })
              }
            )
          }
        ),
        /* @__PURE__ */ jsx20(
          Button8,
          {
            "data-testid": "header_mobile_close_search_button",
            theme: "action",
            onClick: () => togglePopover(false),
            className: "h-12 w-12 bg-transparent px-3 shadow-sm",
            phill: true,
            children: /* @__PURE__ */ jsx20(ChevronIcon2, { className: "h-4 w-4 ltr:rotate-180" })
          }
        )
      ] }),
      /* @__PURE__ */ jsxs11("div", { className: "flex", children: [
        /* @__PURE__ */ jsx20(Category_default, {}),
        /* @__PURE__ */ jsx20(Date_default, {})
      ] })
    ] }),
    /* @__PURE__ */ jsx20("div", { className: "p-4", children: /* @__PURE__ */ jsx20(Content_default, {}) })
  ] });
};
var Content_default2 = MobileSearchContent;

// src/components/layout/header/search/mobile/index.tsx
import { jsx as jsx21 } from "react/jsx-runtime";
var MobileSearch = () => {
  const { t } = useTranslation15("calendar_common");
  const { showPopover, togglePopover } = useSearch();
  const { isLessWidth } = useWindowResize({ width: 1279 });
  if (!isLessWidth) {
    return null;
  }
  return /* @__PURE__ */ jsx21(
    Modal,
    {
      fullscreen: true,
      ignoreHistory: true,
      unstyled: true,
      show: showPopover,
      onClose: () => togglePopover(false),
      className: "data-[state=open]:animate-in bg-body-level-1 data-[state=closed]:animate-out data-[state=closed]:slide-out-to-top-[45%] data-[state=open]:slide-in-from-top-[45%] fixed top-0 z-50 duration-1000",
      render: () => /* @__PURE__ */ jsx21(
        Button9,
        {
          shape: "text",
          theme: "secondary",
          className: "peer px-2",
          onClick: () => togglePopover(true),
          "data-testid": "mobile-search",
          "data-location": "header",
          "aria-label": t("calendar_common:search"),
          children: /* @__PURE__ */ jsx21(SearchIcon3, { className: "mx-auto h-6 w-6 shrink-0" })
        }
      ),
      body: () => /* @__PURE__ */ jsx21(Content_default2, {})
    }
  );
};
var mobile_default = MobileSearch;

// src/components/layout/header/NavigationItem.tsx
import { useRouter as useRouter10, useTranslation as useTranslation16 } from "@wbk/config";
import { Typography as Typography14 } from "@wbk/ui";
import { twMerge as twMerge6 } from "tailwind-merge";
import { jsx as jsx22, jsxs as jsxs12 } from "react/jsx-runtime";
var NavigationItem = (_a) => {
  var _b = _a, { as = "li", href, className, children } = _b, props = __objRest(_b, ["as", "href", "className", "children"]);
  const { pathname } = useRouter10();
  const { t } = useTranslation16("calendar_common");
  const { locale } = useRouter10();
  const isActive = (pathname == null ? void 0 : pathname.replace(`/${locale}`, "")) === (href == null ? void 0 : href.replace(`/${locale}`, ""));
  const isSoon = !href || href === "#";
  const Component = as;
  return /* @__PURE__ */ jsxs12(
    Component,
    __spreadProps(__spreadValues({
      "data-selected": isActive,
      "data-disabled": isSoon,
      className: twMerge6(
        "data-[selected=true]:text-body-dark text-body-dark hover:text-body-dark group relative shrink-0 transition",
        "[&_path]:data-[selected=true]:text-body-dark [&_path]:hover:text-body-dark lg:[&_path]:text-body-dark",
        "[&_path]:text-body-dark [&_path]:data-[selected=true]:text-body-dark [&_path]:group-data-[home=true]:group-data-[sticky=false]:text-secondary",
        "data-[disabled=true]:text-text-disabled",
        className
      )
    }, props), {
      children: [
        isSoon && /* @__PURE__ */ jsx22(
          Typography14,
          {
            className: "absolute -translate-y-1/2 ltr:left-2 rtl:right-2",
            variant: "body-XS",
            color: "tertiary",
            children: t("calendar_common:soon")
          }
        ),
        typeof children === "function" ? children({ isActive, disabled: isSoon }) : children,
        /* @__PURE__ */ jsx22("div", { className: "bg-body-dark absolute bottom-0 left-1/2 h-0.5 w-0 max-w-20 -translate-x-1/2 transition-all peer-hover:w-1/2 peer-focus:w-1/2 peer-aria-disabled:hidden group-data-[selected=true]:w-1/2 peer-data-[selected=true]:w-1/2" })
      ]
    })
  );
};
var NavigationItem_default = NavigationItem;

// src/components/layout/header/submenu/index.tsx
import { jsx as jsx23, jsxs as jsxs13 } from "react/jsx-runtime";
var SubMenu = () => {
  const { t } = useTranslation17("calendar_common");
  const { pathname } = useRouter11();
  const isMap = pathname == null ? void 0 : pathname.includes("/map");
  const { locale } = useRouter11();
  return /* @__PURE__ */ jsxs13("ul", { className: "flex items-center", children: [
    !isMap && /* @__PURE__ */ jsx23(NavigationItem_default, { href: "!#", className: "block shrink-0 xl:hidden", children: /* @__PURE__ */ jsx23(mobile_default, {}) }),
    /* @__PURE__ */ jsx23(NavigationItem_default, { href: "/map", className: "hidden shrink-0 lg:block", children: ({ isActive }) => /* @__PURE__ */ jsx23(
      Button10,
      {
        as: Link4,
        href: `/${locale}/map`,
        shape: "text",
        className: "text-primary peer px-2",
        "aria-label": t("calendar_common:map"),
        children: isActive ? /* @__PURE__ */ jsx23(MapIcon, { "data-active": isActive, className: "h-6 w-6 shrink-0" }) : /* @__PURE__ */ jsx23(MapOutlinedIcon, { "data-active": isActive, className: "h-6 w-6 shrink-0" })
      }
    ) }),
    /* @__PURE__ */ jsx23(NavigationItem_default, { href: "/favorites", className: "shrink-0", children: ({ isActive }) => /* @__PURE__ */ jsx23(FavoritesNav_default, { isActive }) }),
    /* @__PURE__ */ jsx23(NavigationItem_default, { href: "!#", className: "shrink-0", children: /* @__PURE__ */ jsx23(LocalizationSwitcher_default, {}) })
  ] });
};
var submenu_default = SubMenu;

// src/components/layout/header/search/desktop/index.tsx
import { Input, Typography as Typography17 } from "@wbk/ui";
import { SearchIcon as SearchIcon4 } from "@wbk/svg";
import { useTranslation as useTranslation20 } from "@wbk/config";
import { useWindowScroll } from "@wbk/hooks";

// src/components/layout/header/search/desktop/Category.tsx
import { Button as Button11, Typography as Typography15 } from "@wbk/ui";
import { useRouter as useRouter12, useTranslation as useTranslation18 } from "@wbk/config";
import { ChevronIcon as ChevronIcon3, FourSquares as FourSquares2 } from "@wbk/svg";
import { jsx as jsx24, jsxs as jsxs14 } from "react/jsx-runtime";
var Category2 = () => {
  const { locale: lang } = useRouter12();
  const { t } = useTranslation18("calendar_common");
  const { category, setCategory } = useSearch();
  const { data: categories } = useGetCategories({
    lang,
    limit: 20,
    where: { parent_exists: false }
  });
  return /* @__PURE__ */ jsx24(
    ThemeMenu_default,
    {
      render: ({ open, selected }) => /* @__PURE__ */ jsxs14(
        Button11,
        {
          shape: "text",
          className: "group-data-[home=true]:group-data-[sticky=false]:text-secondary px-1",
          onClick: open,
          children: [
            /* @__PURE__ */ jsx24(Typography15, { variant: "body-S", children: selected == null ? void 0 : selected.label }),
            /* @__PURE__ */ jsx24(ChevronIcon3, { className: "h-2 w-2 shrink-0 rotate-90" })
          ]
        }
      ),
      item: { theme: "primary" },
      menu: { sideOffset: 35 },
      onChange: (value) => {
        setCategory(value == null ? void 0 : value.value);
      },
      value: category,
      options: [
        {
          label: t("calendar_common:everything"),
          text: /* @__PURE__ */ jsxs14("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx24(FourSquares2, { className: "h-5 w-5" }),
            /* @__PURE__ */ jsx24(Typography15, { variant: "body-S", children: t("calendar_common:everything") })
          ] }),
          value: ""
        },
        ...(categories == null ? void 0 : categories.map((category2) => ({
          label: category2.title,
          text: /* @__PURE__ */ jsxs14("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx24(ContentfulMedia_default, { media: category2.icon, className: "h-5 w-5" }),
            /* @__PURE__ */ jsx24(Typography15, { variant: "body-S", children: category2.title })
          ] }),
          value: category2.slug
        }))) || []
      ],
      hideErrorSpace: true
    }
  );
};
var Category_default2 = Category2;

// src/components/layout/header/search/desktop/Date.tsx
import { useMemo as useMemo2, useState as useState4 } from "react";
import { Button as Button12, DayPicker as DayPicker2, Divider as Divider4, Typography as Typography16 } from "@wbk/ui";
import { dateAdd, endOfMonth, formatDate as formatDate3, isSameDay as isSameDay2 } from "@wbk/utils";
import { useRouter as useRouter13, useTranslation as useTranslation19 } from "@wbk/config";
import { ChevronIcon as ChevronIcon4 } from "@wbk/svg";
import { jsx as jsx25, jsxs as jsxs15 } from "react/jsx-runtime";
var DateSearch2 = () => {
  const [open, setOpen] = useState4(false);
  const { t } = useTranslation19("calendar_common");
  const { locale } = useRouter13();
  const { from, to, setDate } = useSearch();
  const today = /* @__PURE__ */ new Date();
  const tomorrow = dateAdd({ date: today, interval: "day", value: 1 });
  const weekStart = today;
  const weekEnd = dateAdd({ date: today, interval: "day", value: 6 });
  const monthStart = today;
  const monthEnd = endOfMonth(today);
  const isToday = from && to && isSameDay2(from, today) && isSameDay2(to, today);
  const isTomorrow = tomorrow && from && isSameDay2(from, tomorrow);
  const isWeek = from && to && isSameDay2(from, weekStart) && isSameDay2(to, weekEnd);
  const isMonth = from && to && isSameDay2(from, monthStart) && isSameDay2(to, monthEnd);
  const date = useMemo2(() => {
    if (from && to) {
      const sameDay = isSameDay2(from, to);
      const formattedFrom = formatDate3(from, locale, {
        day: "2-digit",
        month: "short"
      });
      if (sameDay) {
        return formattedFrom;
      }
      const formattedTo = formatDate3(to, locale, {
        day: "2-digit",
        month: "short"
      });
      return `${formattedFrom} - ${formattedTo}`;
    }
    return t("calendar_common:any_time");
  }, [from, locale, t, to]);
  return /* @__PURE__ */ jsx25(
    ThemePopover_default,
    {
      open,
      onOpenChange: setOpen,
      content: /* @__PURE__ */ jsxs15("div", { className: "!space-y-6", children: [
        /* @__PURE__ */ jsxs15("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx25(
            ThemeButton_default,
            {
              shape: isToday ? "solid" : "outlined",
              className: "border-paper",
              onClick: () => setDate(today, today),
              children: t("calendar_common:date.today")
            }
          ),
          /* @__PURE__ */ jsx25(
            ThemeButton_default,
            {
              shape: isTomorrow ? "solid" : "outlined",
              className: "border-paper",
              onClick: () => setDate(tomorrow, tomorrow),
              children: t("calendar_common:date.tomorrow")
            }
          ),
          /* @__PURE__ */ jsx25(
            ThemeButton_default,
            {
              shape: isWeek ? "solid" : "outlined",
              className: "border-paper",
              onClick: () => setDate(weekStart, weekEnd),
              children: t("calendar_common:date.week")
            }
          ),
          /* @__PURE__ */ jsx25(
            ThemeButton_default,
            {
              shape: isMonth ? "solid" : "outlined",
              className: "border-paper",
              onClick: () => setDate(monthStart, monthEnd),
              children: t("calendar_common:date.month")
            }
          )
        ] }),
        /* @__PURE__ */ jsx25(
          DayPicker2,
          {
            mode: "range",
            selected: { from, to },
            fromDate: /* @__PURE__ */ new Date(),
            defaultMonth: from,
            numberOfMonths: 2,
            onSelect: (value) => {
              setDate(value == null ? void 0 : value.from, value == null ? void 0 : value.to);
            },
            components: {
              CaptionLabel: ({ displayMonth }) => {
                return /* @__PURE__ */ jsx25(Typography16, { className: "px-2", children: formatDate3(displayMonth, locale, { month: "long", year: "numeric" }) });
              }
            }
          }
        ),
        /* @__PURE__ */ jsx25(Divider4, {}),
        /* @__PURE__ */ jsxs15("div", { className: "flex items-center justify-between", children: [
          /* @__PURE__ */ jsx25(
            ThemeButton_default,
            {
              theme: "transparent",
              shape: "text",
              className: "group-data-[home=true]:group-data-[sticky=false]:text-secondary",
              onClick: () => {
                setDate(void 0, void 0);
                setOpen(false);
              },
              children: t("calendar_common:clear")
            }
          ),
          /* @__PURE__ */ jsx25(ThemeButton_default, { onClick: () => setOpen(false), className: "min-w-24 p-3", children: t("calendar_common:done") })
        ] })
      ] }),
      className: "w-fit max-w-3xl",
      sideOffset: 35,
      children: /* @__PURE__ */ jsxs15(
        Button12,
        {
          shape: "text",
          className: "group-data-[home=true]:group-data-[sticky=false]:text-secondary px-1",
          children: [
            /* @__PURE__ */ jsx25(Typography16, { variant: "body-S", children: date }),
            /* @__PURE__ */ jsx25(ChevronIcon4, { className: "h-2 w-2 shrink-0 rotate-90" })
          ]
        }
      )
    }
  );
};
var Date_default2 = DateSearch2;

// src/components/layout/header/search/desktop/index.tsx
import { jsx as jsx26, jsxs as jsxs16 } from "react/jsx-runtime";
var DesktopSearch = () => {
  const { t } = useTranslation20("calendar_common");
  const { events, showPopover, togglePopover, onSearch, total, searchState, onSubmit, clearAll } = useSearch();
  const { y } = useWindowScroll();
  return /* @__PURE__ */ jsx26(
    ThemePopover_default,
    {
      content: /* @__PURE__ */ jsx26(Content_default, {}),
      cancel: !!searchState && (events == null ? void 0 : events.length) ? { theme: "primary", label: t("calendar_common:clear"), onClick: clearAll } : false,
      action: !!searchState && (events == null ? void 0 : events.length) ? {
        theme: "primary",
        label: t("calendar_common:show_all_results", { count: total }),
        onClick: onSubmit
      } : false,
      sideOffset: 35,
      onOpenAutoFocus: (e) => e.preventDefault(),
      onPointerDownOutside: () => {
        if (showPopover) {
          togglePopover(false);
        }
      },
      open: showPopover,
      children: /* @__PURE__ */ jsxs16(
        "form",
        {
          className: "relative mx-auto hidden grow overflow-hidden xl:block",
          onSubmit: (e) => {
            e.preventDefault();
            onSubmit();
          },
          children: [
            /* @__PURE__ */ jsx26("div", { className: "absolute top-1/2 flex -translate-y-1/2 items-center gap-2 ltr:left-2 rtl:right-2", children: /* @__PURE__ */ jsxs16(
              ThemeButton_default,
              {
                type: "submit",
                "aria-label": "Search",
                theme: "transparent",
                className: "items-center justify-center p-2 text-sm",
                children: [
                  /* @__PURE__ */ jsx26("span", { className: "3xl:block hidden", children: t("calendar_common:search") }),
                  /* @__PURE__ */ jsx26(
                    SearchIcon4,
                    {
                      "data-sticky": y >= 40,
                      className: "3xl:hidden group-data-[home=true]:group-data-[sticky=false]:text-secondary block h-5 w-5 shrink-0"
                    }
                  )
                ]
              }
            ) }),
            /* @__PURE__ */ jsx26(
              Input,
              {
                autoComplete: "off",
                type: "search",
                name: "search",
                inputMode: "search",
                placeholder: t("calendar_common:search"),
                groupClassName: "w-full",
                className: "!text-body-S bg-input/10 hover:bg-input/20 text-body-dark border-body-dark/10 focus:border-body-dark focus:bg-input/10 rounded-XL py-S group-data-[home=true]:group-data-[sticky=false]:text-secondary group-data-[home=true]:group-data-[sticky=false]:focus:border-secondary placeholder:text-text-secondary px-10",
                value: searchState,
                "data-testid": "home_search_input",
                "data-sticky": y >= 40,
                onChange: (value) => {
                  if (!showPopover) {
                    togglePopover(true);
                  }
                  onSearch(value);
                },
                onFocus: () => {
                  togglePopover(true);
                }
              }
            ),
            /* @__PURE__ */ jsxs16("div", { className: "absolute top-1/2 flex -translate-y-1/2 items-center gap-2 ltr:right-2 rtl:left-2", children: [
              /* @__PURE__ */ jsx26(Date_default2, {}),
              /* @__PURE__ */ jsx26(Category_default2, {}),
              /* @__PURE__ */ jsx26(
                ThemeButton_default,
                {
                  type: "submit",
                  "aria-label": "Search",
                  theme: "primary",
                  className: "px-S py-XXS mx-1",
                  children: /* @__PURE__ */ jsx26(Typography17, { variant: "body-S", strong: true, className: "text-secondary", children: t("calendar_common:search") })
                }
              )
            ] })
          ]
        }
      )
    }
  );
};
var desktop_default = DesktopSearch;

// src/components/layout/header/Desktop.tsx
import { jsx as jsx27, jsxs as jsxs17 } from "react/jsx-runtime";
var DesktopHeader = ({ config }) => {
  const { locale, pathname, params } = useRouter14();
  const isHomeOrEventPage = (pathname == null ? void 0 : pathname.replace(locale, "")) === "/" || !!((params == null ? void 0 : params.slug) && (params == null ? void 0 : params.category));
  const isMap = pathname == null ? void 0 : pathname.includes("/map");
  const { y } = useWindowScroll2();
  return /* @__PURE__ */ jsx27(
    "header",
    {
      "data-sticky": y >= 40,
      "data-home": isHomeOrEventPage,
      className: twMerge7(
        "bg-body group z-20 hidden h-20 w-full content-center transition-all lg:block",
        isHomeOrEventPage ? "data-[sticky=false]:rounded-radius relative top-8 mx-auto -mb-20 data-[sticky=true]:sticky data-[sticky=true]:top-0 data-[sticky=true]:h-24 data-[sticky=false]:max-w-[calc(min(100%,1440px))] data-[sticky=true]:max-w-full data-[sticky=true]:rounded-none data-[sticky=false]:bg-transparent data-[sticky=true]:shadow-md" : "sticky top-0"
      ),
      children: /* @__PURE__ */ jsxs17("nav", { className: twMerge7("container flex items-center gap-4", isMap && "justify-between"), children: [
        /* @__PURE__ */ jsx27(
          Link5,
          {
            to: `/${locale}`,
            className: "relative block h-12 shrink-0 hover:opacity-90 group-data-[home=true]:group-data-[sticky=false]:h-10",
            "data-location": "header",
            children: /* @__PURE__ */ jsx27(
              ContentfulMedia_default,
              {
                media: config.logo,
                className: "h-full object-contain",
                alt: config.title
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs17("div", { className: "rounded-L mx-XS container flex grow items-center justify-between gap-6 bg-white backdrop-blur-xl group-data-[home=true]:group-data-[sticky=false]:bg-transparent", children: [
          /* @__PURE__ */ jsx27("ul", { className: "py-M hidden items-center gap-1 lg:flex", children: config.header.navigationCollection.items.map((button) => {
            if (!button)
              return null;
            return /* @__PURE__ */ jsx27(NavigationItem_default, { href: button.href, children: ({ disabled }) => /* @__PURE__ */ jsx27(
              ContentfulButton_default,
              {
                className: "text-body-M font-label group-data-[home=true]:group-data-[sticky=false]:text-secondary peer whitespace-nowrap px-2 aria-disabled:bg-transparent",
                shape: button.shape,
                theme: button.theme,
                button,
                "data-location": "header",
                "data-category": button.label,
                "aria-disabled": disabled,
                disabled
              }
            ) }, button.id);
          }) }),
          !isMap && /* @__PURE__ */ jsx27(desktop_default, {}),
          /* @__PURE__ */ jsx27(submenu_default, {})
        ] })
      ] })
    }
  );
};
var Desktop_default = DesktopHeader;

// src/components/layout/header/Mobile.tsx
import { useCycle } from "motion/react";
import { useWindowScroll as useWindowScroll3 } from "@wbk/hooks";
import { twMerge as twMerge8 } from "tailwind-merge";
import { Link as Link7, useRouter as useRouter17 } from "@wbk/config";

// src/components/layout/header/SideMenu.tsx
import { AnimatePresence as AnimatePresence2, motion as motion2 } from "motion/react";
import { Link as Link6, useRouter as useRouter16 } from "@wbk/config";

// src/components/layout/header/MenuButton.tsx
import { AnimatePresence, motion } from "motion/react";
import { useRouter as useRouter15 } from "@wbk/config";
import { Button as Button13 } from "@wbk/ui";
import { jsx as jsx28, jsxs as jsxs18 } from "react/jsx-runtime";
var MenuButton = ({ isOpen, toggleOpen }) => {
  const { locale } = useRouter15();
  return /* @__PURE__ */ jsx28(
    Button13,
    {
      shape: "text",
      className: "z-30 h-6 w-6 flex-col p-0",
      theme: "secondary",
      onClick: () => toggleOpen(),
      "aria-label": isOpen ? "Close Mobile Menu" : "Open Mobile Menu",
      children: /* @__PURE__ */ jsxs18(AnimatePresence, { mode: "popLayout", children: [
        /* @__PURE__ */ jsx28(
          motion.div,
          {
            initial: { rotateZ: 0, x: 0 },
            animate: {
              rotateZ: isOpen ? -45 : 0,
              y: isOpen ? "150%" : 0
            },
            className: "bg-body-dark group-data-[home=true]:group-data-[sticky=false]:bg-secondary h-0.5 w-5 rounded-full"
          },
          1
        ),
        !isOpen && /* @__PURE__ */ jsx28(
          motion.div,
          {
            className: "bg-body-dark group-data-[home=true]:group-data-[sticky=false]:bg-secondary h-0.5 w-5 rounded-full",
            initial: { x: locale === "ar" ? "100%" : "-100%", opacity: 0 },
            animate: { x: 0, opacity: 1 },
            exit: { x: locale === "ar" ? "100%" : "-100%", opacity: 0 }
          },
          2
        ),
        /* @__PURE__ */ jsx28(
          motion.div,
          {
            initial: { rotateZ: 0 },
            animate: {
              rotateZ: isOpen ? 45 : 0,
              y: isOpen ? "-150%" : 0
            },
            className: "bg-body-dark group-data-[home=true]:group-data-[sticky=false]:bg-secondary h-0.5 w-5 rounded-full"
          },
          3
        )
      ] })
    }
  );
};
var MenuButton_default = MenuButton;

// src/components/layout/header/SideMenu.tsx
import { Fragment as Fragment7, jsx as jsx29, jsxs as jsxs19 } from "react/jsx-runtime";
var SideMenu = ({ config, isOpen, toggleOpen }) => {
  const { locale } = useRouter16();
  return /* @__PURE__ */ jsxs19(Fragment7, { children: [
    isOpen && /* @__PURE__ */ jsx29("style", { children: "body{overflow:hidden}" }),
    /* @__PURE__ */ jsx29(AnimatePresence2, { children: isOpen && /* @__PURE__ */ jsx29(
      motion2.div,
      {
        onClick: () => toggleOpen(),
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        className: "bg-body-dark/50 fixed inset-0 z-[9999] backdrop-blur-lg"
      },
      "backdrop"
    ) }),
    /* @__PURE__ */ jsxs19(
      motion2.nav,
      {
        className: "mini-scrollbar bg-secondary/80 text-body-dark rounded-L group fixed top-16 z-[9999] h-[calc(100vh-4rem)] max-h-svh w-full overflow-x-hidden backdrop-blur-xl ltr:left-0 rtl:right-0",
        initial: "closed",
        animate: isOpen ? "open" : "closed",
        variants: {
          open: { width: "90%", maxWidth: 450 },
          closed: { width: 0, maxWidth: 450 }
        },
        children: [
          /* @__PURE__ */ jsxs19("div", { className: "sticky inset-x-0 top-0 flex h-20 items-center justify-between gap-5 border-l px-4", children: [
            /* @__PURE__ */ jsx29(
              Link6,
              {
                to: `/${locale}`,
                className: "relative z-30 block h-12 shrink-0 hover:opacity-90",
                "data-location": "header",
                children: /* @__PURE__ */ jsx29(
                  ContentfulMedia_default,
                  {
                    media: config.logo,
                    className: "h-full object-contain",
                    alt: config.title
                  }
                )
              }
            ),
            /* @__PURE__ */ jsx29(MenuButton_default, { isOpen, toggleOpen })
          ] }),
          /* @__PURE__ */ jsxs19("div", { className: "flex h-[calc(100vh-9rem)] w-full flex-col justify-between divide-y", children: [
            /* @__PURE__ */ jsx29("ul", { className: "space-y-2 p-4", role: "menu", children: config.header.navigationCollection.items.map((button) => {
              if (!button)
                return null;
              return /* @__PURE__ */ jsx29(
                NavigationItem_default,
                {
                  href: button.href,
                  className: "w-fit",
                  role: "menuitem",
                  children: ({ disabled }) => /* @__PURE__ */ jsx29(
                    ContentfulButton_default,
                    {
                      className: "text-body-L font-label peer whitespace-nowrap px-2 aria-disabled:bg-transparent",
                      shape: button.shape,
                      theme: button.theme,
                      button,
                      "data-location": "header",
                      "data-category": button.label,
                      "aria-disabled": disabled,
                      disabled,
                      onClick: () => toggleOpen()
                    }
                  )
                },
                button.id
              );
            }) }),
            /* @__PURE__ */ jsx29("div", { className: "border-primary/50 w-full border-t p-4", children: /* @__PURE__ */ jsx29(
              Weather_default,
              {
                className: "bg-primary/20 text-primary w-full whitespace-nowrap backdrop-blur-xl",
                color: "primary",
                onClick: () => toggleOpen()
              }
            ) })
          ] })
        ]
      }
    )
  ] });
};
var SideMenu_default = SideMenu;

// src/components/layout/header/Mobile.tsx
import { Fragment as Fragment8, jsx as jsx30, jsxs as jsxs20 } from "react/jsx-runtime";
var MobileHeader = ({ config }) => {
  const { locale, pathname, params } = useRouter17();
  const isHomeOrEventPage = (pathname == null ? void 0 : pathname.replace(locale, "")) === "/" || !!((params == null ? void 0 : params.slug) && (params == null ? void 0 : params.category));
  const { y } = useWindowScroll3();
  const [isOpen, toggleOpen] = useCycle(false, true);
  return /* @__PURE__ */ jsxs20(Fragment8, { children: [
    /* @__PURE__ */ jsx30(SideMenu_default, { config, isOpen, toggleOpen }),
    /* @__PURE__ */ jsx30(
      "header",
      {
        "data-sticky": y >= 20,
        "data-home": isHomeOrEventPage,
        className: twMerge8(
          "bg-body group z-20 block w-full content-center py-4 transition-all lg:hidden",
          isHomeOrEventPage ? "data-[sticky=false]:rounded-radius relative top-6 mx-auto -mb-20 h-12 data-[sticky=true]:sticky data-[sticky=true]:top-0 data-[sticky=true]:h-24 data-[sticky=false]:max-w-[calc(min(100%,1440px))] data-[sticky=true]:max-w-full data-[sticky=true]:rounded-none data-[sticky=false]:bg-transparent data-[sticky=false]:py-1 data-[sticky=true]:shadow-md" : "sticky top-0"
        ),
        children: /* @__PURE__ */ jsxs20("nav", { className: "container flex items-center gap-4", children: [
          /* @__PURE__ */ jsx30(
            Link7,
            {
              to: `/${locale}`,
              className: "relative z-30 block h-12 shrink-0 hover:opacity-90 group-data-[home=true]:group-data-[sticky=false]:h-9 md:group-data-[home=true]:group-data-[sticky=false]:h-11",
              "data-location": "header",
              children: /* @__PURE__ */ jsx30(
                ContentfulMedia_default,
                {
                  media: config.logo,
                  className: "h-full object-contain",
                  alt: config.title
                }
              )
            }
          ),
          /* @__PURE__ */ jsxs20("div", { className: "container flex grow items-center justify-between gap-2", children: [
            /* @__PURE__ */ jsx30(MenuButton_default, { isOpen, toggleOpen }),
            /* @__PURE__ */ jsx30(submenu_default, {})
          ] })
        ] })
      }
    )
  ] });
};
var Mobile_default = MobileHeader;

// src/components/layout/header/index.tsx
import { jsx as jsx31, jsxs as jsxs21 } from "react/jsx-runtime";
var Header = ({ config }) => {
  return /* @__PURE__ */ jsxs21(provider_default, { children: [
    /* @__PURE__ */ jsx31(Desktop_default, { config }),
    /* @__PURE__ */ jsx31(Mobile_default, { config })
  ] });
};
var header_default = Header;

// src/components/layout/footer/index.tsx
import { Button as Button14, Typography as Typography20 } from "@wbk/ui";
import { WorldIcon as WorldIcon2 } from "@wbk/svg";
import { useRouter as useRouter18, useTranslation as useTranslation21 } from "@wbk/config";
import { useCurrency as useCurrency2 } from "@wbk/currency";

// src/components/layout/footer/Copyright.tsx
import { Typography as Typography18 } from "@wbk/ui";
import { jsx as jsx32 } from "react/jsx-runtime";
var Copyright = ({ text }) => {
  if (!text)
    return null;
  return /* @__PURE__ */ jsx32(Typography18, { color: "text-secondary", children: text });
};
var Copyright_default = Copyright;

// src/components/layout/footer/VisitCity.tsx
import { Typography as Typography19 } from "@wbk/ui";
import { jsx as jsx33, jsxs as jsxs22 } from "react/jsx-runtime";
var VisitCity = ({ section }) => {
  var _a;
  const cards = (_a = section == null ? void 0 : section.contentCollection) == null ? void 0 : _a.items;
  if (!(cards == null ? void 0 : cards.length))
    return null;
  const color = section.titleColor;
  return /* @__PURE__ */ jsxs22(DecoratedSection_default, { section, className: "border-paper space-y-12", children: [
    /* @__PURE__ */ jsxs22("div", { className: "relative z-10 space-y-2", children: [
      /* @__PURE__ */ jsx33(Typography19, { as: "h2", variant: "heading-XXL", children: section.title }),
      section.subtitle && /* @__PURE__ */ jsx33(Typography19, { variant: "body-L", children: section.subtitle })
    ] }),
    /* @__PURE__ */ jsx33("ul", { className: "grid grid-cols-2 md:grid-cols-4", children: cards.map((card, index) => {
      return /* @__PURE__ */ jsx33(
        "li",
        {
          "data-border": index % 2 === 0,
          className: "border-body-level-2 group border-b md:border-b-0",
          children: /* @__PURE__ */ jsx33(
            IconItem_default,
            {
              className: "rounded-L p-L block h-full w-full text-start",
              card,
              btnProps: { style: { color } }
            }
          )
        },
        card.id
      );
    }) })
  ] });
};
var VisitCity_default = VisitCity;

// src/components/layout/footer/index.tsx
import { Fragment as Fragment9, jsx as jsx34, jsxs as jsxs23 } from "react/jsx-runtime";
var Footer = ({ config }) => {
  var _a, _b, _c, _d;
  const { t } = useTranslation21("calendar_common");
  const { locale } = useRouter18();
  const { currency } = useCurrency2();
  return /* @__PURE__ */ jsx34(Fragment9, { children: /* @__PURE__ */ jsxs23("footer", { className: "border-paper group/footer border-t", children: [
    /* @__PURE__ */ jsx34(VisitCity_default, { section: config.footer.visitCity }),
    /* @__PURE__ */ jsxs23("div", { className: "container space-y-4", children: [
      /* @__PURE__ */ jsxs23("div", { className: "flex flex-col items-center justify-center gap-6 md:flex-row md:justify-between", children: [
        /* @__PURE__ */ jsxs23("div", { className: "flex flex-col items-center gap-6 md:flex-row", children: [
          config.logo && /* @__PURE__ */ jsx34("figure", { className: "block shrink-0", children: /* @__PURE__ */ jsx34(
            ContentfulMedia_default,
            {
              className: "aspect-1 object-contain",
              media: config.logo,
              width: 80,
              height: 80
            }
          ) }),
          /* @__PURE__ */ jsx34("ul", { className: "flex shrink-0 items-center gap-3", children: (_b = (_a = config.socialLinks) == null ? void 0 : _a.iconsCollection) == null ? void 0 : _b.items.map((link) => /* @__PURE__ */ jsx34("li", { className: "rounded-md", children: /* @__PURE__ */ jsx34(
            ContentfulButton_default,
            {
              button: link,
              rel: "noreferrer noopener",
              className: "social_media_follow overflow-hidden rounded-md !p-1",
              "data-location": "footer",
              "data-category": link.label,
              shape: link.shape,
              theme: link.theme
            }
          ) }, link.id)) })
        ] }),
        /* @__PURE__ */ jsx34(
          LocalizationSwitcher_default,
          {
            render: ({ open }) => /* @__PURE__ */ jsxs23(Button14, { shape: "outlined", onClick: open, arrow: true, children: [
              /* @__PURE__ */ jsx34(WorldIcon2, { className: "h-5 w-5 shrink-0" }),
              /* @__PURE__ */ jsx34(Typography20, { children: `${t(`common:${locale}`)} | ${currency.name}` })
            ] })
          }
        )
      ] }),
      /* @__PURE__ */ jsxs23("div", { className: "flex flex-wrap items-center justify-center gap-2 border-t py-4 md:gap-6", children: [
        /* @__PURE__ */ jsx34(Copyright_default, { text: config.footer.copyrightText }),
        ((_d = (_c = config.footer.navigationCollection) == null ? void 0 : _c.items) == null ? void 0 : _d.length) > 0 && /* @__PURE__ */ jsx34("ul", { className: "flex items-center gap-2", children: config.footer.navigationCollection.items.map((link) => {
          if (!link)
            return;
          return /* @__PURE__ */ jsx34("li", { children: /* @__PURE__ */ jsx34(
            ContentfulButton_default,
            {
              button: link,
              rel: "noreferrer noopener",
              "data-location": "footer",
              "data-category": link.label,
              className: "p-1 underline-offset-2 hover:underline",
              shape: link.shape
            }
          ) }, link.id);
        }) })
      ] })
    ] })
  ] }) });
};
var footer_default = Footer;

// src/components/layout/Layout.tsx
import { jsx as jsx35, jsxs as jsxs24 } from "react/jsx-runtime";
var Layout = ({ footer = "default", children }) => {
  const { locale, pathname } = useRouter19();
  const { config, isLoading } = useConfig_default();
  const isHome = (pathname == null ? void 0 : pathname.replace(locale, "")) === "/";
  return /* @__PURE__ */ jsxs24(Fragment10, { children: [
    isLoading && !isHome ? /* @__PURE__ */ jsx35("header", { className: "bg-body h-20 w-full" }) : config ? /* @__PURE__ */ jsx35(header_default, { config }) : null,
    /* @__PURE__ */ jsx35("main", { id: "main", children }),
    footer === "default" && /* @__PURE__ */ jsx35(Suspense, { children: !!config && /* @__PURE__ */ jsx35(footer_default, { config }) })
  ] });
};
var Layout_default = Layout;

export {
  provider_default,
  ThemeBottomSheet_default,
  provider_default2,
  ThemeInput_default,
  Category_default2 as Category_default,
  Date_default2 as Date_default,
  Layout_default
};
//# sourceMappingURL=chunk-GLRCLOWE.mjs.map